import { render, staticRenderFns } from "./NewOrderView.vue?vue&type=template&id=b5ccd516&scoped=true&"
import script from "./NewOrderView.vue?vue&type=script&lang=js&"
export * from "./NewOrderView.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderView.vue?vue&type=style&index=0&id=b5ccd516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ccd516",
  null
  
)

export default component.exports